import React from 'react';
import { useNavigate } from 'react-router-dom';
import pb from '../../lib/pocketbase';
import './UserDashboard.css';

function UserDashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    pb.authStore.clear();
    navigate('/');
  };
  return (
    <div className="user-dashboard">
      <h3>Mon Espace</h3>
            <p>Bienvenue dans votre espace personnel. Ici, vous pourrez bientôt consulter vos commandes et gérer vos informations.</p>
      <button onClick={handleLogout} className="logout-button">Se déconnecter</button>
    </div>
  );
}

export default UserDashboard;
